import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import ContentTitle from '../contentTitle';
import NewsList from '../newsList';
import { rel } from '../../../utils/rel';

class PicList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        hasTopic: PropTypes.bool,
        isVideo: PropTypes.bool,
        hasEnd: PropTypes.bool,
    };

    render() {
        let videoContent = [];
        let { content } = this.props;
        const { hasTopic, isVideo, hasEnd } = this.props;

        if (hasTopic) {
            videoContent = content.slice(0, 1);
            content = content.slice(1);
        }

        const pic = content[0];
        const list = content.slice(1, 6);
        const end = content.slice(6, 7);

        return (
            <div>
                {hasTopic ? <ContentTitle content={videoContent} /> : ''}
                <div className={`${isVideo ? styles.video_list : styles.pic_list}`}>
                    {pic.thumbnail ? (
                        <div className={`${isVideo ? styles.video_pic : styles.pic}`}>
                            <a href={pic.url} target="_blank" rel={rel}>
                                <img src={pic.thumbnail} alt={pic.title} title={pic.title} />
                            </a>
                            {isVideo ? (
                                <div className={styles.play_btn}>
                                    <a href={pic.url} target="_blank" rel={rel} />
                                </div>
                            ) : (
                                ''
                            )}
                            <div className={styles.txt_bg} />
                            <div className={styles.txt}>
                                <a href={pic.url} target="_blank" rel={rel}>
                                    {pic.title}
                                </a>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={styles.list}>
                        <NewsList content={list} isContent />
                    </div>
                </div>
                {hasEnd ? <NewsList content={end} isList /> : ''}
            </div>
        );
    }
}

export default errorBoundary(PicList);
